/**
 * Dashboard Module Configuration
 *
 * Provides the main Dashboard view and sidebar navigation entry.
 * Visible to all authenticated users.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const dashboardModule: AppModule = {
    id: 'dashboard',

    navigation: {
        label: 'Dashboard',
        icon: 'gauge',
        path: '/dashboard',
        order: 1, // First item in sidebar
        pages: [],
    },

    routes,
}

export default dashboardModule
